export default {
	heading: "New Team",
	addMembersHeading: "Add team members",
	createButton: "Create Team",
	cancelButton: "Cancel",
	teamNameFieldHint: "",
	teamNameFieldPlaceholder: "Enter the team name",
	teamNameFieldLabel: "Team Name",
	memberBeingAddedFieldLabel: "Email",
	memberBeingAddedFieldPlaceholder: "e.g., snape{'@'}hogwarts.edu",
	memberBeingAddedFieldHint: "Enter the email of the person you wish to add to the team.",
	memberBeingAddedButton: "Add",
};
